var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upper"},[_c('label',[_vm._v("YOU'RE NOT ALONE")]),(_vm.collegeHasCrisisPhoneFeature)?_c('h3',[_vm._v("24/7 On-Demand Emotional Support and Crisis Resources")]):_c('h3',[_vm._v("24/7 Crisis Resources")])])}
var staticRenderFns = []

export { render, staticRenderFns }